import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type SharedContentState = {
  hasSharedContentNotification: boolean;
};

const initialState: SharedContentState = {
  hasSharedContentNotification: false
};

const sharedContentNotification = createSlice({
  name: "SharedContent",
  initialState,
  reducers: {
    setHasSharedContentNotification: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.hasSharedContentNotification = action.payload;
    }
  }
});

export const { setHasSharedContentNotification } =
  sharedContentNotification.actions;
export const SharedContentSlice = "SharedContent";
export default sharedContentNotification.reducer;
